import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  IconButton,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { masterAPI } from "../../../Masters/dataConfig";
import { axiosPrivate } from "../../../../axios/axios";
import NormalTable from "../../../../Component/NormalTable";
import { color } from "../../../../StyleData/Config";
import { DeleteOutline } from "@mui/icons-material";
import { toast } from "react-toastify";

const TaskDocDialog = ({ open, onClose, taskId }) => {
  const [docData, setDocData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [confirmDeleteId, setConfirmDeleteId] = useState(null);

  useEffect(() => {
    if (open && taskId) {
      getData();
    }
  }, [open, taskId]);

  const getData = async () => {
    setLoading(true);
    const link = masterAPI["workOrderTask"].getDocumentByTaskId;
    await axiosPrivate
      .get(`${link}/${taskId}`)
      .then((res) => setDocData(res.data.result || []))
      .catch(() => setDocData([]))
      .finally(() => setLoading(false));
  };

  const handleDownload = async (id) => {
    const link = masterAPI["workOrderTask"].downloadDocument;
    await axiosPrivate
      .get(`${link}/${id}`)
      .then((res) => window.open(res.data.result.documentPath))
      .catch((e) => console.log(e));
  };

  const handleDelete = async () => {
    const link = masterAPI["workOrderTask"].deleteDocument;
    await axiosPrivate
      .delete(`${link}/${confirmDeleteId}`)
      .then((res) => {
        setConfirmDeleteId(null);
        getData();
      })
      .catch((e) => {
        toast.error(e.response?.data?.failureMessage || "Failed to delete document");
        setConfirmDeleteId(null);
      });
  };

  const columns = [
    {
      Header: "Doc Name",
      accessor: "documentName",
      Cell: ({ cell }) => (
        <Typography
          sx={{ fontSize: "inherit", fontWeight: "inherit", color: "blue", cursor: "pointer" }}
          onClick={() => handleDownload(cell.row.original.documentId)}
        >
          {cell.value?.split("/")[2]?.split("_")[1] || cell.value}
        </Typography>
      ),
    },
    {
      Header: "Doc Type",
      accessor: "documentType",
    },
    {
      Header: "Actions",
      Cell: ({ cell }) => (
        <IconButton onClick={() => setConfirmDeleteId(cell.row.original.documentId)}>
          <DeleteOutline
            sx={{ fontSize: color.masterEditDelButton, color: color.masterEditDelButtonColor }}
          />
        </IconButton>
      ),
    },
  ];

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle
          sx={{
            color: color.masterPageTitleColor,
            fontSize: color.masterPageTitleFontSize,
            fontWeight: color.masterPageTitleFontWeight,
          }}
        >
          Uploaded Documents {docData[0]?.workOrderTaskName ? `— ${docData[0].workOrderTaskName}` : ""}
        </DialogTitle>
        <Divider />
        <Box sx={{ px: 2, py: 1 }}>
          {loading ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
              <CircularProgress size={28} />
            </Box>
          ) : docData.length === 0 ? (
            <Typography sx={{ textAlign: "center", color: "#999", fontSize: "14px", py: 4 }}>
              No documents uploaded
            </Typography>
          ) : (
            <NormalTable data={docData} columns={columns} />
          )}
        </Box>
        <Divider />
        <DialogActions>
          <Button onClick={onClose}>Close</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={!!confirmDeleteId} onClose={() => setConfirmDeleteId(null)} maxWidth="xs">
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>Are you sure you want to delete this document?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmDeleteId(null)}>Cancel</Button>
          <Button variant="contained" color="error" onClick={handleDelete}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TaskDocDialog;
